export const supportedLanguages: ['en'] = ['en'];
